export default __webpack_public_path__ + "static/media/logo-white.1d83a89f.png";